(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvMultipleEnumInput', function () {
            
            return  {
                templateUrl: 'app/fieldinput/multiple-enum-input.tmpl.html',
                require: "ngModel",
                scope: {
                    value: '=ngModel',
                    field: '='
                },
                controller: ['$scope', function ($scope) {
                    var drvCtrl = this;
                    drvCtrl.showSuffix = showSuffix;
                    drvCtrl.enumerationDeliminter = ',';
                    drvCtrl.addEnumerationValue = addEnumerationValue;
                    drvCtrl.removeEnumerationValue = removeEnumerationValue;
                    drvCtrl.loadEnumerations = loadEnumerations;
                    drvCtrl.updateEnumerationValue = updateEnumerationValue;

                    activate();

                    function activate() {
                        var idFriendlyFieldName = drvCtrl.field.Name.replace(/ /g, '-space-');
                        drvCtrl.enumListId = idFriendlyFieldName + '-EnumList';
                        drvCtrl.availableEnumListId = idFriendlyFieldName + '-AvailableEnum';
                        drvCtrl.currentEnumListId = idFriendlyFieldName + '-CurrentEnum';

                        $scope.dragControlListeners = {
                            containment: '#' + drvCtrl.enumListId,
                            containerPositioning: 'relative',
                            accept: function (sourceItemHandleScope, destSortableScope) {
                                var result = false;

                                if (!angular.isUndefined(sourceItemHandleScope.sortableScope.element[0])) {
                                    switch (sourceItemHandleScope.sortableScope.element[0].id) {
                                        case drvCtrl.availableEnumListId:
                                        case drvCtrl.currentEnumListId:
                                            result = true;
                                            break;
                                    }
                                }

                                return result;
                            },
                            itemMoved: function (event) {
                                drvCtrl.updateEnumerationValue();
                            },
                            orderChanged: function (event) {
                                drvCtrl.updateEnumerationValue();
                            }
                        };

                        drvCtrl.availableEnumerations = [];
                        drvCtrl.currentEnumerations = [];
                        drvCtrl.loadEnumerations();

                        // If the list of enumerations passed to this directive changes, the internal lists need to be updated
                        $scope.$watch('drvCtrl.field.Enumerations', function (newVal, oldVal) {
                            if (newVal !== oldVal) {
                                fieldEnumerationsChanged();
                            }
                        }, true);
                    }

                    function addEnumerationValue(enumeration) {
                        if (!angular.isUndefined(enumeration) && enumeration !== null && enumeration !== '') {
                            // Remove enumeration from the available list
                            _.remove(drvCtrl.availableEnumerations, function (n) { return n === enumeration; });

                            // Add the enumeartion to currentEnumerations and the ng model.
                            drvCtrl.currentEnumerations.push(enumeration);
                            drvCtrl.selectedEnumeration = null;
                        }
                    }

                    function removeEnumerationValue(enumeration) {
                        // Remove the enumeartion from currentEnumerations and the ng model.
                        if (!angular.isUndefined(enumeration) && enumeration !== null && enumeration !== '') {
                            _.remove(drvCtrl.currentEnumerations, function (n) { return n === enumeration; });

                            // Rebuild the available list for enumeartions
                            drvCtrl.availableEnumerations = drvCtrl.field.Enumerations.split(drvCtrl.enumerationDeliminter);
                            angular.forEach(drvCtrl.currentEnumerations, function (currentEnumeration) {
                                _.remove(drvCtrl.availableEnumerations, function (n) { return n === currentEnumeration; });
                            });

                            drvCtrl.selectedEnumeration = null;
                        }
                    }

                    function arrayToDelimintedString(array, deliminter) {
                        var result = '';
                        var firstField = true;

                        angular.forEach(array, function (n) {
                            if (firstField) {
                                result = n;
                                firstField = false;
                            }
                            else {
                                result = result + deliminter + n;
                            }
                        });

                        return result;
                    }

                    function delimintedStringToArray(string, deliminter) {
                        var result = string.split(deliminter);

                        return result;
                    }

                    function loadEnumerations() {
                        drvCtrl.availableEnumerations = drvCtrl.field.Enumerations.split(drvCtrl.enumerationDeliminter);

                        if (!angular.isUndefined(drvCtrl.value) && drvCtrl.value !== null && drvCtrl.value !== '') {
                            drvCtrl.currentEnumerations = drvCtrl.value.split(drvCtrl.enumerationDeliminter);
                            angular.forEach(drvCtrl.currentEnumerations, function (enumeration) {
                                _.remove(drvCtrl.availableEnumerations, function (n) { return n === enumeration; });
                            });
                        }
                    }

                    function updateEnumerationValue() {
                        var enumerationString = arrayToDelimintedString(drvCtrl.currentEnumerations, drvCtrl.enumerationDeliminter);
                        drvCtrl.value = enumerationString;
                    }

                    /*
                     * If the list of enumerations supplied to the directive changes, the available enumerations, current enumerations and value need to be updated
                     */
                    function fieldEnumerationsChanged() {
                        var availableEnumerations = drvCtrl.field.Enumerations.split(drvCtrl.enumerationDeliminter);

                        drvCtrl.currentEnumerations = _.filter(drvCtrl.currentEnumerations, function (currentEnumeration) {
                            return _.find(availableEnumerations, function (availableEnumeration) {
                                return availableEnumeration === currentEnumeration;
                            });
                        });

                        angular.forEach(drvCtrl.currentEnumerations, function (currentEnumeration) {
                            _.remove(availableEnumerations, function (n) { return n === currentEnumeration; });
                        });

                        drvCtrl.availableEnumerations = availableEnumerations;

                        updateEnumerationValue();
                    }

                    function showSuffix() {
                        return !_.isNil(drvCtrl.field) && !_.isNil(drvCtrl.field.Suffix) && drvCtrl.field.Suffix !== '';
                    }
                }],
                controllerAs: 'drvCtrl',
                bindToController: {
                    value: '=ngModel',
                    field: '='
                }
            };
        });
})();